// extracted by mini-css-extract-plugin
export var chevronIcon = "_c8-2";
export var teamName = "_c8-1";
export var teamSwitcherButton = "_c8-0";